'use client'
import { Tbody as ChakraTableBody } from '@chakra-ui/react'
import { forwardRef, LegacyRef } from 'react'

import { TableBodyProps } from './TableBody.types'

export default forwardRef(function Tbody(
  props: TableBodyProps,
  ref: LegacyRef<HTMLTableSectionElement>
) {
  return <ChakraTableBody {...props} ref={ref} translate="no" />
})
